import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { updateExpiredPassword } from '../redux/AuthCRUD'
import { useIntl } from 'react-intl'
import { ReCaptchaButton } from '../../../../_template/layout/core/ReCaptchaButton'
import { useDispatch } from 'react-redux'
import * as auth from '../redux/AuthRedux'


const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
}

const passwordExpiredRenewSchema = Yup.object().shape({
    currentPassword: Yup.string()
        .required('Zorunlu Alan'),
    newPassword: Yup.string()
        .matches(RegExp(`^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?['[\\\]/{()}_.+#?!@$%^&*-])(?!.*[\\\s]).{8,}$`), "Şifreniz en az 1 sayı, 1 sembol, 1 büyük harf ve 1 küçük harf içermeli, ayrıca en az 8 karakterden oluşmalıdır.")
        .required('Zorunlu Alan'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Şifreler Aynı Değil')
})

export function PasswordExpiredRenew() {
    const intl = useIntl()
    const [loading, setLoading] = useState(false)
    const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
    const dispatch = useDispatch()

    const formikUpdatePassword = useFormik({
        initialValues,
        validationSchema: passwordExpiredRenewSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true)
            setHasErrors(undefined)
            updateExpiredPassword(values.currentPassword, values.newPassword, values.confirmPassword)
                .then(({ data }) => {
                    setHasErrors(false)
                    setLoading(false)
                    if (data.status) {
                        setStatus('Şifreniz Güncellenmiştir. Giriş sayfasına giderek giriş yapabilirsiniz.')
                        dispatch(auth.actions.otpConfirmed(data.data))
                        dispatch(auth.actions.requestUser())
                    } else {
                        setHasErrors(true)
                        setSubmitting(false)
                        setStatus(data.message)
                    }
                })
                .catch(() => {
                    setHasErrors(true)
                    setLoading(false)
                    setSubmitting(false)
                    setStatus('Bir hata alındı. Lütfen daha sonra tekrar deneyiniz.')
                })
        },
    })


    return (
        <>
            <form
                className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                noValidate
                id='kt_password_expired_form'
                onSubmit={formikUpdatePassword.handleSubmit}
            >
                <div className='text-center mb-10'>
                    {/* begin::Title */}
                    <h1 className='text-dark mb-3'>Şifremi Güncelle</h1>
                    {/* end::Title */}
                </div>
                <div className='mb-10 bg-light-info p-8 rounded'>
                    <div className='text-info font-weight-bold'>Şifreniz en az 1 sayı, 1 sembol, 1 büyük harf ve 1 küçük harf içermeli, ayrıca en az 8 karakterden oluşmalıdır.</div>
                </div>

                {/* begin::Title */}

                {formikUpdatePassword.status ? (
                    <div className='mb-lg-15 alert alert-danger'>
                        <div className='alert-text font-weight-bold'>{intl.formatMessage({ id: formikUpdatePassword.status })}</div>
                    </div>
                ) : (<></>
                )}

                {/* begin::Form group */}
                <div className='fv-row mb-10'>
                    <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: 'AUTH.INPUT.CURRENT_PASSWORD' })}</label>
                    <input
                        placeholder={intl.formatMessage({ id: 'AUTH.INPUT.CURRENT_PASSWORD' })}
                        {...formikUpdatePassword.getFieldProps('currentPassword')}
                        className={clsx(
                            'form-control form-control-lg',
                            { 'is-invalid': formikUpdatePassword.touched.currentPassword && formikUpdatePassword.errors.currentPassword },
                            {
                                'is-valid': formikUpdatePassword.touched.currentPassword && !formikUpdatePassword.errors.currentPassword,
                            }
                        )}
                        type='password'
                        name='currentPassword'
                        autoComplete='off'
                    />
                    {formikUpdatePassword.touched.currentPassword && formikUpdatePassword.errors.currentPassword && (
                        <div className='fv-plugins-message-container invalid-feedback'>
                            <div className='fv-help-block'>
                                <span role='alert'>{formikUpdatePassword.errors.currentPassword}</span>
                            </div>
                        </div>
                    )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group */}
                <div className='fv-row mb-10'>
                    <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: 'AUTH.INPUT.NEW_PASSWORD' })}</label>
                    <input
                        placeholder={intl.formatMessage({ id: 'AUTH.INPUT.NEW_PASSWORD' })}
                        {...formikUpdatePassword.getFieldProps('newPassword')}
                        className={clsx(
                            'form-control form-control-lg',
                            { 'is-invalid': formikUpdatePassword.touched.newPassword && formikUpdatePassword.errors.newPassword },
                            {
                                'is-valid': formikUpdatePassword.touched.newPassword && !formikUpdatePassword.errors.newPassword,
                            }
                        )}
                        type='password'
                        name='newPassword'
                        autoComplete='off'
                    />
                    {formikUpdatePassword.touched.newPassword && formikUpdatePassword.errors.newPassword && (
                        <div className='fv-plugins-message-container invalid-feedback'>
                            <div className='fv-help-block'>
                                <span role='alert'>{formikUpdatePassword.errors.newPassword}</span>
                            </div>
                        </div>
                    )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group */}
                <div className='fv-row mb-10'>
                    <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: 'AUTH.INPUT.CONFIRM_PASSWORD' })}</label>
                    <input
                        placeholder={intl.formatMessage({ id: 'AUTH.INPUT.CONFIRM_PASSWORD' })}
                        {...formikUpdatePassword.getFieldProps('confirmPassword')}
                        className={clsx(
                            'form-control form-control-lg',
                            { 'is-invalid': formikUpdatePassword.touched.confirmPassword && formikUpdatePassword.errors.confirmPassword },
                            {
                                'is-valid': formikUpdatePassword.touched.confirmPassword && !formikUpdatePassword.errors.confirmPassword,
                            }
                        )}
                        type='password'
                        name='confirmPassword'
                        autoComplete='off'
                    />
                    {formikUpdatePassword.touched.confirmPassword && formikUpdatePassword.errors.confirmPassword && (
                        <div className='fv-plugins-message-container invalid-feedback'>
                            <div className='fv-help-block'>
                                <span role='alert'>{formikUpdatePassword.errors.confirmPassword}</span>
                            </div>
                        </div>
                    )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group */}
                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>

                    <ReCaptchaButton
                        id='kt_password_expired_submit'
                        className='btn btn-lg btn-primary fw-bolder me-4'
                        disabled={formikUpdatePassword.isSubmitting || !formikUpdatePassword.isValid}
                        loading={loading}
                        spanClassName='indicator-label'
                        text='Şifremi Güncelle'
                        actionName='EXPIREDPASSWORDRENEWSUBMIT'
                    />
                    <Link to='/auth/login'>
                        <button
                            type='button'
                            id='kt_login_password_reset_form_1_cancel_button'
                            className='btn btn-lg btn-light-primary fw-bolder'
                        >
                            Geri
                        </button>
                    </Link>{' '}
                </div>
                {/* end::Form group */}
            </form>
        </>
    )

}